import { gql } from "@apollo/client";

export const GetJunctions = gql`
  query GetJunctions(
    $token: String!
    $after: Cursor
    $first: Int
    $customerID: ID!
    $companyID: ID!
    $subsidiaryID: ID!
    $empID: ID!
    $priority: [PriorityType]
    $jType: [String]
    $siteID: ID!
    $ldgrID: ID
    $queryType: JunctionQueryType!
    $orderBy: AtsJunctionsOrder
    $name: String
    $junctionStatus: [JunctionStatus]
    $startDate: Time
    $endDate: Time
  ) {
    GetJunctions(
      token: $token
      after: $after
      first: $first
      customerID: $customerID
      companyID: $companyID
      subsidiaryID: $subsidiaryID
      empID: $empID
      jType: $jType
      priority: $priority
      junctionStatus: $junctionStatus
      siteID: $siteID
      ldgrID: $ldgrID
      queryType: $queryType
      startDate: $startDate
      endDate: $endDate
      orderBy: $orderBy
      where: { or: [{ nameContainsFold: $name }, { codeContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          name
          address
          place
          state
          pin
          country
          code
          priority
          alias
          jType
          arms
          icon
          poles
          ldgrID
          ticketStatus
          junctionStatus
          remarks
          companyID
          latitude
          longitude
          ticketStatus
          isLocValidated
          vendorDetails {
            id
            desc
          }
          company {
            name
          }
          subsidiary {
            name
          }
          site {
            name
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetJunctionsForDashboard = gql`
  query GetJunctions(
    $token: String!
    $after: Cursor
    $first: Int
    $customerID: ID!
    $companyID: ID!
    $subsidiaryID: ID!
    $empID: ID!
    $priority: [PriorityType]
    $jType: [String]
    $siteID: ID!
    $orderBy: AtsJunctionsOrder
    $name: String
    $ldgrID: ID
    $queryType: JunctionQueryType!
    $ticketStatus: [TicketStatus]
    $junctionStatus: [JunctionStatus]
  ) {
    GetJunctions(
      token: $token
      after: $after
      first: $first
      customerID: $customerID
      companyID: $companyID
      subsidiaryID: $subsidiaryID
      empID: $empID
      jType: $jType
      priority: $priority
      siteID: $siteID
      orderBy: $orderBy
      ticketStatus: $ticketStatus
      ldgrID: $ldgrID
      junctionStatus: $junctionStatus
      queryType: $queryType
      where: { or: [{ nameContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          name
          alias
          code
          arms
          icon
          priority
          remarks
          isLocValidated
          vendorDetails {
            desc
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetJunctionNode = gql`
  query GetJunctionNode($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      ... on AtsJunctions {
        id
        name
        code
        address
        place
        state
        pin
        country
        latitude
        longitude
        priority
        alias
        jType
        arms
        icon
        poles
        ldgrID
        junctionStatus
        customerID
        companyID
        subsidiaryID
        siteID
        remarks
        images
        subsidiary {
          name
        }
        site {
          name
        }
        company {
          name
        }
        vendorDetails{
          desc
        }
      }
    }
  }
`;

export const ValidateJunctionForImport = gql`
  query ValidateJunctionForImport(
    $token: String!
    $customerID: ID!
    $companyID: ID!
    $subsidiaryName: String!
    $siteName: String!
    $junctionName: String!
  ) {
    ValidateJunctionForImport(
      token: $token
      customerID: $customerID
      companyID: $companyID
      subsidiaryName: $subsidiaryName
      siteName: $siteName
      junctionName: $junctionName
    )
  }
`;

export const ExportJunctionTemplate = gql`
  query ExportJunctionTemplate(
    $token: String!
    $customerID: ID!
    $atSiteLevel: Boolean!
  ) {
    ExportJunctionTemplate(
      token: $token
      customerID: $customerID
      atSiteLevel: $atSiteLevel
    )
  }
`;

export const GetJunctionTypes = gql`
  query GetJunctionTypes($token: String!, $customerID: ID!) {
    GetJunctionTypes(token: $token, customerID: $customerID)
  }
`;

export const GetSubOrSiteOrJunctionById = gql`
  query GetSubOrSiteOrJunctionById($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on AtsSubsidiary {
        id
        name
      }

      ... on AtsSubsidiarySite {
        id
        name
      }

      ... on AtsJunctions {
        id
        name
      }
    }
  }
`;

export const GetJunctionCounters = gql`
  query GetJunctionCounters(
    $token: String!
    $customerID: ID!
    $empID: ID!
    $byJType: Boolean!
  ) {
    GetJunctionCounters(
      token: $token
      customerID: $customerID
      empID: $empID
      byJType: $byJType
    ) {
      jType
      vendor_name
      totalJunctions
      working
      notWorking
      planned
      inProgress
      installed
      shifting
      commissioned
      deCommissioned
    }
  }
`;

export const GetJunctionNodeForMultiple = gql`
  query GetJunctionNodeForMultiple($ids: [ID!]!, $token: String!) {
    nodes(ids: $ids, token: $token) {
      ... on AtsJunctions {
        id
        name
        code
        address
        place
        state
        pin
        country
        customer {
          name
        }
      }
    }
  }
`;

export const GetProjectsForMom = gql`
  query GetProjectsForMom(
    $token: String!
    $customerID: ID!
    $empID: ID!
    $momID: ID!
    $latest: Boolean!
  ) {
    GetProjectsForMom(
      token: $token
      customerID: $customerID
      empID: $empID
      momID: $momID
      latest: $latest
    ) {
      projectID
      projectName
      vendorName
      pmuCount
      vendorRespCount
      momExists
      viewed
    }
  }
`;

export const GetJunctionWithOutToken = gql`
  query GetJunctionWithOutToken($junctionId: ID!) {
    GetJunctionWithOutToken(junctionId: $junctionId) {
      id
      name
      code
      address
      place
      state
      pin
      country
      latitude
      longitude
      priority
      alias
      jType
      arms
      icon
      poles
      ldgrID
      junctionStatus
      customerID
      companyID
      subsidiaryID
      siteID
      remarks
      images
   
      subsidiary {
        name
      }
      site {
        name
        contactPersonMobile
      }
      company {
        name
      }
      customer{
        name
      }
      vendorDetails{
        desc
        supplier_details{
          phone
        }
      }
    }
  }
`;
